<script lang="ts" setup>
import DefinitionListSection from '../../DefinitionListSection.vue';
import ItemListSection from '../../ItemListSection.vue';
import WhereToConsultCard from '../../WhereToConsult/WhereToConsultCard.vue';
import CashflowImg from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/marriageCost/WhereToConsultCard/05_cashflow.png/05_cashflow.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  imageNumber: number;
}>();
</script>

<template>
  <WhereToConsultCard
    title="結婚資金を効率よく準備する方法"
    :image-number="imageNumber"
  >
    <p>結婚資金を効率よく準備したい方は、以下の方法を試してみましょう。</p>
    <h3>ライフプランシミュレーションをして家計のムダを見直す</h3>
    <PinchImageModal
      :src="CashflowImg"
      alt="ライフプラン表(キャッシュフロー表)のイメージ"
    />
    <p>
      無駄な支出を見直して結婚資金をねん出するために、ライフプランシミュレーションがおすすめです。
    </p>
    <DefinitionListSection>
      <dt>ライフプランシミュレーションのメリット</dt>
      <dd>
        <ul>
          <li>いくら結婚資金を貯めるべきかがわかる</li>
          <li>現在の家計の問題点が洗い出せる</li>
          <li>
            必要な貯金額や問題点が可視化されるので、効果的な対策を考えられる
          </li>
          <li>将来の見通しを立てることで漠然としたお金の不安を解消できる</li>
        </ul>
      </dd>
    </DefinitionListSection>
    <p>
      お金のプロにシミュレーションを依頼すれば、詳細な数値を出してもらうことができ、適切な対策のアドバイスがもらえます。
    </p>
    <h3>結婚資金専用の口座を作成して毎月一定額を貯金する</h3>
    <p>
      ライフプランシミュレーションをして必要な貯金額がわかったら、結婚資金用の口座を作成しましょう。以下のメリットにより、お金が貯まりやすくなると考えられます。
    </p>
    <ItemListSection>
      <li>生活費と口座をわけることで使い込んでしまう心配がない</li>
      <li>貯金の進捗状況が一目でわかる</li>
    </ItemListSection>
    <p>
      銀行口座に預ける場合は、金利の高いネット銀行の口座や定期預金口座に預け、さらに自動積立機能（自動振替機能）を活用すると、普通口座から自動で結婚資金用口座に振替ができ便利です。
    </p>
  </WhereToConsultCard>
</template>

<style lang="scss" module></style>
